import { FC, ReactNode } from "react";
import RadioButton from "../RadioButton/RadioButton";
import styles from './RadioButtonGroup.module.scss';
import { ErrorMessageIcon } from "../ErrorMessageIcon/ErrorMessageIcon";

type Props = {
  label?: string | ReactNode,
  required?: boolean,
  errorMessage?: string,
  options: {
    label: string,
    value: string,
    selected: boolean,
  }[],
  onChange?: (value: {
    label: string,
    value: string,
    selected: boolean,
  }[]) => void,
  readOnly?: boolean,
}

export const RadioButtonGroup: FC<Props> = ({ label, options, onChange, required, errorMessage, readOnly }) => {
  return (
    <div className={styles.container}>
      {label && (
        <span className={styles.label}>
          <span className={styles.innerLabelContainer}>{label} {required && <span className={styles.required}>*</span>}</span>
          {errorMessage && (
            <ErrorMessageIcon
              style={{ whiteSpace: 'nowrap' }}
              errorMessage={errorMessage}
            />
          )}
        </span>
      )}
      {options.map(option => (
        <RadioButton
          key={option.value}
          style={{ width: 'fit-content' }}
          checked={option.selected}
          label={option.label}
          value={option.value}
          readonly={readOnly}
          onChange={event => {
            const { value } = event.target;

            onChange?.(options.map(x => {
              x.selected = x.value === value;
              return x;
            }));
          }}
        />
      ))}
    </div>
  )
}